import type { ResidentReportModel } from "../types/resident-report.types";
import { formatReportDate } from "../utils/report-formatters";

export function EventParticipation({ events }: Pick<ResidentReportModel, "events">) {
  return (
    <section className="report-card event-participation">
      <header>
        <div>
          <p className="report-eyebrow">Programs</p>
          <h2>Attendance across programs</h2>
        </div>
        <span>Last 12 months</span>
      </header>
      {events.length === 0 ? (
        <p className="report-empty-state">No event participation data available.</p>
      ) : (
        <div className="event-participation__table-wrap">
          <div
            className="event-participation__head"
            role="row"
          >
            <span>Program</span>
            <span>Sessions</span>
            <span>Attendance rate</span>
            <span>Last attended</span>
            <span>Status</span>
          </div>
          {events.map((event) => (
            <div
              key={event.id}
              className="event-participation__row"
              role="row"
            >
              <div>
                <strong>{event.name}</strong>
                {event.department ? <small>{event.department}</small> : null}
              </div>
              <span>{event.attendance}</span>
              <div className="event-attendance-rate">
                <i style={{ width: `${event.attendanceRate ?? 0}%` }} />
                <b>
                  {event.attendanceRate ?? "—"}
                  {event.attendanceRate !== undefined ? "%" : ""}
                </b>
              </div>
              <span>{formatReportDate(event.eventDate)}</span>
              <span className="event-status">{event.status ?? "—"}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
